import React, { useEffect } from 'react'
import { HolyDayType } from '../../types/holiday/types'
import moment from 'moment-jalaali'
import { enToPersianChar } from '../activities'
import { getDateOfTimeZoneDate, getDateYear, monthNames, returnSeparatedDayMonth } from '../../shared/helper'


export const Holidays = ({ holidays, selectedYear }: { holidays: HolyDayType[], selectedYear: string }) => {


    useEffect(() => {
        console.log(handleDividingList(holidays))
    }, [])
    const handleDividingList = (arr: HolyDayType[]) =>
        Array.from({ length: Math.ceil(arr.length / 10) }, (v, i) =>
            arr.slice(i * 10, i * 10 + 10)
        );
    return (
        <div className='holidays-container'>
            <div className='d-flex' >
                {handleDividingList(holidays.filter((ho: HolyDayType) => getDateYear(ho.date) === selectedYear)).map((div: HolyDayType[], idx: number) =>
                    <div key={idx} >
                        <ul>
                            {div.map((item: HolyDayType, idx: number) => {
                                const { month, day } = returnSeparatedDayMonth(item.date)
                                return (<li key={idx}>
                                    {/* <div>   <label>{enToPersianChar(idx + 1)}-</label></div> */}
                                    <div>

                                        <label>

                                            <span> {enToPersianChar(day)}</span>
                                            {monthNames(month)}
                                        </label>
                                    </div>
                                    <div>{item.title}</div>
                                </li>)
                            })}
                        </ul>
                    </div>
                )}
            </div>
            <ul>

            </ul>
        </div>
    )
}
